<div class="clinical-onboarding-config">
  <form [formGroup]="form">
    <div class="config-row">
      <span>{{ 'components.clinical-onboarding.config.enable-label' | translate }}</span>
      <mat-slide-toggle color="primary" formControlName="enabled"></mat-slide-toggle>
    </div>

    @if (form.get('enabled').value) {
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.clinical-onboarding.config.deadline-days' | translate }}</mat-label>
            <input matInput type="number" min="1" max="365" formControlName="contract_deadline_days">
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.clinical-onboarding.config.reminder-offsets' | translate }}</mat-label>
            <input matInput formControlName="reminder_offsets_days" placeholder="7, 20, 28">
            <mat-hint>{{ 'components.clinical-onboarding.config.reminder-offsets-hint' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
    }

    <div class="d-flex justify-content-end">
      <button mat-raised-button color="primary" [disabled]="saving" (click)="save()">
        {{ 'generic.buttons.save' | translate }}
      </button>
    </div>
  </form>
</div>
